import angular from 'angular';
angular
  .module('cloudX')
  .factory('invoicingSvc', [
    '$q',
    'resourceFactorySvc',
    'transactionHttpSvc',
    'flySvc',
    '$timeout',
    '$http',
    'appUrls',
    invoicingSvc,
  ]);

function invoicingSvc(
  $q,
  resourceFactorySvc,
  transactionHttpSvc,
  flySvc,
  $timeout,
  $http,
  appUrls,
) {
  var billableRegistrations = [];
  var transactions = [];
  var unpaidInvoices = [];
  const processingInvoicesInfo = {
    count: 0,
    reloading: false,
    currentRequest: null,
    refreshAgain: false,
  };

  function showError(error) {
    flySvc.error(error.data.code, error.data.parameters);
  }

  function reloadRegistrations() {
    billableRegistrations.clear();
    return resourceFactorySvc.get('invoice').customerBillable({}, function(data) {
      data.forEach(function(item) {
        billableRegistrations.push(item);
      });
    }).$promise;
  }

  function reloadTransactions() {
    transactions.clear();
    return transactionHttpSvc.openTransactions(null, true).then(function(data) {
      data.forEach(function(item) {
        transactions.push(item);
      });
    });
  }

  function reloadUnpaidInvoices(takeNrOfInvoices = 10, invoiceFilters = {}) {
    unpaidInvoices.clear();
    return retrieveUnpaidInvoices(takeNrOfInvoices, invoiceFilters).then(result => {
      result.forEach(function(inv) {
        unpaidInvoices.push(inv);
      });
    }).$promise;
  }

  function retrieveUnpaidInvoices(takeNrOfInvoices = 10, invoiceFilters = {}) {
    return resourceFactorySvc.get('invoice').query(
      {
        filter: {
          dueAmount: {
            greater: 0.001,
          },
          status: {
            greater: 1, // Greater or equals
          },
          isInvoice: {
            items: [true],
          },
        },
        ...invoiceFilters,
        sort: ['date', 'number'],
        desc: false,
        page: 0,
        take: takeNrOfInvoices,
      },
      function(data) {
        return data;
      },
      showError,
    ).$promise;
  }

  function searchUnpaidInvoices(searchValue, invoiceFilters = {}) {
    return resourceFactorySvc.get('invoice').query(
      {
        filter: {
          dueAmount: {
            greater: 0.001,
          },
          status: {
            greater: 1, // Greater or equals
          },
          isInvoice: {
            items: [true],
          },
        },
        ...invoiceFilters,
        searchValue,
        sort: ['date', 'number'],
        desc: false,
        page: 0,
        take: 20,
      },
      function(data) {
        return data;
      },
      showError,
    ).$promise;
  }

  //reloadRegistrations();

  function reloadProcessingInvoicesInfo(force = false) {
    if (!force && processingInvoicesInfo.currentRequest !== null) {
      processingInvoicesInfo.refreshAgain = true; //Prevent multiple calls at the same time
      return;
    }

    processingInvoicesInfo.refreshAgain = false;
    processingInvoicesInfo.reloading = true;
    processingInvoicesInfo.currentRequest = $http
      .get(`${appUrls.api}/api/Invoice/ProcessingCount`)
      .then(
        ({ data }) => {
          processingInvoicesInfo.count = data || 0;
          $timeout(() => {
            if (processingInvoicesInfo.refreshAgain) {
              reloadProcessingInvoicesInfo(true);
            } else {
              processingInvoicesInfo.currentRequest = null;
            }
          }, 1000);
        },
        error => {
          flySvc.error(error);
          processingInvoicesInfo.currentRequest = null;
        },
      )
      .finally(() => {
        processingInvoicesInfo.reloading = false;
      });
  }

  return {
    getBillableRelations: function() {
      return billableRegistrations;
    },
    reloadBillableRelations: reloadRegistrations,

    getTransactions: function() {
      return transactions;
    },
    reloadTransactions: reloadTransactions,

    getUnpaidInvoices: function() {
      return unpaidInvoices;
    },
    retrieveUnpaidInvoices: retrieveUnpaidInvoices,
    reloadUnpaidInvoices: reloadUnpaidInvoices,
    searchUnpaidInvoices: searchUnpaidInvoices,

    getProcessingInvoicesInfo: function() {
      reloadProcessingInvoicesInfo();
      return processingInvoicesInfo;
    },
    reloadProcessingInvoicesInfo,
  };
}
